import { Organization } from "../organization/organization.model";
import { CrudAbstractModel } from "../crud-abstract/crud-abstract.model";
import { TeamLogo } from "./team-logo/team-logo.model";

export class Team extends CrudAbstractModel {
  constructor(
    public id: number,
    private name: string,
    private logo: TeamLogo,
    private organization?: Organization,
    private organizationName?: string,
    private userCount?: number,
  ) {
    super(id);
  }

  public getId(): number {
    return this.id;
  }

  public getName(): string {
    return this.name;
  }

  public getLogo(): TeamLogo {
    return this.logo;
  }

  public getOrganization(): Organization {
    return this.organization;
  }

  public getOrganizationName(): string {
    return this.organizationName;
  }

  public getUserCount(): number {
    return this.userCount;
  }

  public get visibleOrganizationName(): string {
    return this.organizationName
      ? this.organizationName
      : this.organization.getName();
  }

  public getRequestParams() {
    return {
      name: this.getName(),
      logo: this.getLogo(),
      organizationName: this.getOrganizationName(),
      organization: this.getOrganization()
        ? this.getOrganization().getId()
        : null,
    };
  }
}
